var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.dataset.id)?_c('el-tree',{ref:"tree",attrs:{"props":_vm.props,"load":_vm.loadNode,"lazy":"","node-key":"value","default-expanded-keys":['中国']},on:{"node-click":_vm.nodeClick}}):_c('p',[_vm._v("loading....")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }